document.addEventListener("DOMContentLoaded", function() {
  // Apply zoom logic only for mobile devices (e.g., viewport width <= 768px)
  if (window.innerWidth <= 0) {
    console.log("Mobile device detected – applying zoom logic.");

    // Select all zoom container elements
    const containers = document.querySelectorAll('.zoom-container');
    if (!containers || containers.length === 0) {
      console.warn("No zoom container found. Please ensure that elements have the '.zoom-container' class in your HTML.");
      return;
    }

    // Loop through each container and attach individual event listeners
    containers.forEach(function(container) {
      // Set initial CSS properties (you may also set these via CSS media queries)
      container.style.transformOrigin = "center center";
      container.style.transition = "transform 0.3s ease"; // Adjust the duration if you want a slower or faster transition
      container.style.touchAction = "none"; // Required for proper mobile pinch gesture handling

      // Function to update inverse scaling for dots (if a child element with the class '.slider-dots' exists)
      function updateDots(scaleFactor) {
        const dots = container.querySelector('.slider-dots');
        if (dots) {
          // Apply the inverse scale to keep the dots at constant size (1/scaleFactor)
          dots.style.transform = "scale(" + (1 / scaleFactor) + ")";
        }
      }

      // Track the zoom state for this container individually
      let zoomed = false;

      // ----- Click/Tap Toggle Zoom for the individual container -----
      container.addEventListener("click", function() {
        if (zoomed) {
          container.style.transform = "scale(1)";
          updateDots(1); // Reset dots scaling to default
          zoomed = false;
        } else {
          const factor = 1.5; // Adjust zoom factor as desired
          container.style.transform = "scale(" + factor + ")";
          updateDots(factor);
          zoomed = true;
        }
      });

      // ----- Pinch-to-Zoom using Hammer.js for this container -----
      if (typeof Hammer !== 'undefined') {
        const hammerManager = new Hammer.Manager(container);
        const pinch = new Hammer.Pinch();
        hammerManager.add(pinch);

        let currentScale = 1;
        let lastScale = 1;
        const minScale = 1;
        const maxScale = 3;

        // On pinch start, store the current scale and remove the transition for immediate response
        hammerManager.on('pinchstart', function(e) {
          lastScale = currentScale;
          container.style.transition = "none";
        });

        // Update scale during pinch gesture continuously
        hammerManager.on('pinch', function(e) {
          currentScale = lastScale * e.scale;
          if (currentScale < minScale) currentScale = minScale;
          if (currentScale > maxScale) currentScale = maxScale;
          container.style.transform = "scale(" + currentScale + ")";
          updateDots(currentScale);
        });

        // On pinch end, restore the smooth transition
        hammerManager.on('pinchend', function(e) {
          container.style.transition = "transform 0.3s ease";
          zoomed = (currentScale !== 1);
        });
      } else {
        console.error("Hammer.js not loaded! Please ensure it's included in theme.liquid.");
      }
    });
  }
});
